import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";

export const BranchListContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 16,
  maxWidth: 800,
  margin: "0 auto"
});

export const BranchRow = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  transition: "all 0.2s ease",
  border: "1px solid #e0e0e0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  cursor: "pointer",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    borderColor: "#1976d2"
  }
});

export const BranchImageWrapper = styled(Box)({
  width: 150,
  height: 150,
  flexShrink: 0,
  overflow: "hidden",
  backgroundColor: "#f5f5f5",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});

export const BranchImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover"
});

export const BranchInfo = styled(Box)({
  flex: 1,
  minWidth: 0,
  padding: "16px 20px"
});

export const BranchName = styled(Typography)({
  fontWeight: 600,
  fontSize: "1.2rem",
  color: "#1a1a1a",
  marginBottom: 8
});

export const BranchMeta = styled(Typography)({
  fontSize: "0.875rem",
  color: "#666",
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 4
});

export const BranchMetaFirst = styled(Typography)({
  fontSize: "0.875rem",
  color: "#666",
  marginBottom: 4
});

export const BranchActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "0 16px"
});

export const ViewLink = styled("a")({
  color: "#1976d2",
  textDecoration: "none",
  fontSize: "0.875rem",
  fontWeight: 500,
  padding: "8px 16px",
  borderRadius: 6,
  backgroundColor: "rgba(25, 118, 210, 0.08)",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(25, 118, 210, 0.15)",
    color: "#1565c0"
  }
});

